import React from 'react';
import type { FilterableEntityTableProps } from 'c-pagination';
import { Box, Grid } from '@mui/material';
import { FlashMessage } from 'c-components';
import TableLoadingRegion from './TableLoadingRegion';

const DefaultRenderer: FilterableEntityTableProps['CustomRenderer'] = ({
    wrapperComponentRef,
    table,
    filterForm,
    loading,
    pagination,
    error,
}) => (
    <Grid container ref={wrapperComponentRef}>
        {filterForm != null && (
            <Grid item xs={12}>
                {filterForm}
            </Grid>
        )}

        <Grid item xs={12}>
            <Box>
                {error && (
                    <Box marginY={1}>
                        <FlashMessage status="error">{error}</FlashMessage>
                    </Box>
                )}
                <TableLoadingRegion loading={loading}>{table}</TableLoadingRegion>
                {pagination}
            </Box>
        </Grid>
    </Grid>
);

export default DefaultRenderer;
